import React, { Component } from 'react';
import { submit, reset, getFormValues, reduxForm, change } from 'redux-form';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AsideContentContainer from '../../components/AsideContentContainer/AsideContentContainer';
import PersonalInformationForm from './PersonalInformationForm/PersonalInformationForm';
import CTABannerContainer from '../../components/CTABannerContainer/CTABannerContainer';
import ToolTip from '../../../shared-components/ToolTip/ToolTip';
import { FormattedHTMLMessage, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import StickyContainer from '../../../shared-components/StickyContainer/StickyContainer';
import StickyBody from '../../../shared-components/StickyBody/StickyBody';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';
import { FORM_ID, FLOW_TYPE, CREDIT_TYPE, PYMT_SECURITY_FORM_ID } from '../../../framework/App/AppConstants';
import { APPLY_TYPE, TERMS_RESOURCES_TO_PREFETCH } from '../../USConstants';
import { PAGE_NAME } from '../../config/pageNames';
import CancelUrl, { COMPONENT_STYLE } from '../../components/CancelUrl/CancelUrl';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import GriffinPhone from 'griffin-paypal/lib/client/phone';
import { formatPhoneNumber } from '../../components/PhoneForm/PhoneFormUtils';
import { CONTEXT_TYPE } from '../../../framework/App/SkeletonPage/SkeletonPageConstants';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import Button, {BUTTON_STYLE} from '../../../shared-components/Button/Button';
import './PersonalInformationPage.less';
import { showPhoneOptOutCheckbox, submitForCreditAccountIdentification } from './PersonalInformationPageAction';
import { handleSubmitFail } from '../../../shared-components/FormElement/FormElementUtils';
import { getInitialFormValues } from '../../config/form';
import { PaymentSecurityCard } from '../../components/PaymentSecurity/PaymentSecurityCard';
import PaymentSecurityPage, { FPTI_PAYMENT_SECURITY_PAGE_NAME, READ_PROGRAM_AGREEMENT_CHECKBOX_KEY } from '../PaymentSecurityPage/PaymentSecurityPage';
import { PYMT_SECURITY_CARD, PYMT_SECURITY_CTRL, PYMT_SECURITY_PAGE } from '../PaymentSecurityPage/PaymentSecurityPageConstants';
import { submitPaymentSecurity } from '../PaymentSecurityPage/PaymentSecurityPageActions';

const LOCALE_PREFIX = 'US/pages/PersonalInformationPage/PersonalInformationPage';

export class PersonalInformationPage extends Component {
    static propTypes = {
        creditType: PropTypes.string.isRequired,
        user: PropTypes.object,
        isPayInFullNowAvailable: PropTypes.bool,
        applicationType: PropTypes.string,
        formValues: PropTypes.object.isRequired,
        formattedPhone: PropTypes.string,
        isMiniBrowser: PropTypes.bool,
        incentivesDetails: PropTypes.object,
        flow: PropTypes.string.isRequired,
        intl: intlShape.isRequired,
        submitCallback: PropTypes.func.isRequired,
        onClickContinue: PropTypes.func,
        onClickX: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        onOpenPaymentSecurityModal: PropTypes.func,
        onClosePaymentSecurityModal: PropTypes.func,
        usTermsUri: PropTypes.string.isRequired,
        hasPaymentSecurity: PropTypes.bool,
        paymentSecurityExperiment: PropTypes.string,
        showPaymentSecurity: PropTypes.bool,
        removePaymentSecurity: PropTypes.func.isRequired,
        submitting: PropTypes.bool, // Redux inject this to indicate if the form submit is still in progress
        handleSubmit: PropTypes.func, // Redux inject this function; use this to pass in the form submit handler!
    };

    static defaultProps = {
        onComponentDidMount: () => {},
        showPaymentSecurity: false,
        hasPaymentSecurity: false,
    };

    state = {
        isPaymentSecurityDetailsVisible: false
    }

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleSubmit = () => {
        const { submitCallback, formValues, applicationType, showPaymentSecurity, hasPaymentSecurity } = this.props;
        return submitCallback(
            { ...formValues }, 
            applicationType, 
            PAGE_NAME.TERMS_PAGE, 
            {
                showPaymentSecurity,
                hasPaymentSecurity
            }
        );
    };

    handleClickX = event => {
        this.props.onClickX(event);
    };

    handleClickContinue = () => {
        const { onClickContinue, formValues } = this.props;
        onClickContinue(formValues);
    };

    getHeader() {
        const flow = this.props.flow;
        // Passing singleColumnLayout as false as the header width will change based on aside content.
        const defaultHeader = (
            <Header
                onCancel={this.handleClickX} singleColumnLayout={false}
            />
        );

        if (flow !== FLOW_TYPE.TESLA && flow !== FLOW_TYPE.VENICE) {
            return defaultHeader;
        }
        return '';
    }

    openPaymentSecurity = () => {
        // Set the overflow on the body to hidden so there are not double scrollbars
        document.body.classList.add('disable-scroll');
        this.setState({
            isPaymentSecurityDetailsVisible: true,
        });
        this.props.onOpenPaymentSecurityModal();
    }

    closePaymentSecurity = () => {
        // Set the overflow on the body to auto so the body will scroll
        document.body.classList.remove('disable-scroll');
        this.setState({
            isPaymentSecurityDetailsVisible: false,
        });
    }

    render() {
        const {
            intl, user, applicationType, flow, usTermsUri,
            hasPaymentSecurity, paymentSecurityExperiment, showPaymentSecurity,
            submitting, handleSubmit, removePaymentSecurity
        } = this.props;
        const { isPaymentSecurityDetailsVisible } = this.state;

        const firstName = _.get(user, 'firstName');

        const header = this.getHeader();

        const ESIGN_TERMS_URL = '/ppcreditapply/terms/esign-syf-us.html';

        let nextButtonText = <FormattedMessage id={`${LOCALE_PREFIX}.agree-review-terms`} />;
        let bmlEsignInfo;

        if (applicationType === APPLY_TYPE.FAST) {
            nextButtonText = <FormattedMessage id={`${LOCALE_PREFIX}.submit-application`} />;
        } else if (showPaymentSecurity && paymentSecurityExperiment !== PYMT_SECURITY_CTRL) {
            nextButtonText = (paymentSecurityExperiment === PYMT_SECURITY_PAGE) ? 'Continue' : 'Continue to Terms';
            bmlEsignInfo = (
                <div className="bmlEsignInfo">
                    <FormattedHTMLMessage
                        id={`${LOCALE_PREFIX}.pymtsec-esign-text-1`}
                    />&nbsp;
                    <PopupLink
                        url={ESIGN_TERMS_URL}
                        className="popup accessible-link"
                        name="esign-consent"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.bmlapply-esign-link-text`}
                        />
                    </PopupLink>&nbsp;
                    <FormattedMessage id={`${LOCALE_PREFIX}.pymtsec-esign-text-2`} />
                </div>
            );
        } else {
            bmlEsignInfo = (
                <div className="bmlEsignInfo">
                    <FormattedHTMLMessage
                        id={`${LOCALE_PREFIX}.bmlapply-esign-text-1`}
                    />&nbsp;
                    <PopupLink
                        url={ESIGN_TERMS_URL}
                        className="popup accessible-link"
                        name="esign-consent"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.bmlapply-esign-link-text`}
                        />
                    </PopupLink>&nbsp;
                    <FormattedMessage id={`${LOCALE_PREFIX}.bmlapply-esign-text-2`} />
                </div>
            );
        }

        const showCtaBanner =
            (flow !== FLOW_TYPE.DIRECT_APP) &&
            (flow !== FLOW_TYPE.TESLA) &&
            (flow !== FLOW_TYPE.VENICE) &&
            (applicationType !== APPLY_TYPE.FAST);

        let ctaBanner = null;
        if (showCtaBanner) {
            ctaBanner = (
                <CTABannerContainer
                    showDefaultGreeting={true}
                />
            );
        }

        const showPaymentSecurityDetails = () => showPaymentSecurity && isPaymentSecurityDetailsVisible;

        return (
            <div className="outerWrapper us-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="PersonalInformationPage">
                            {header}
                            <div id="content">
                                <div id="content-child" className="row-fluid table-layout">
                                    <div
                                        id="content-left"
                                        className={`${(flow === FLOW_TYPE.TESLA) ? 'span13' : 'span12'} table-cell`}
                                    >
                                        <StickyContainer>
                                            <StickyBody>
                                                {ctaBanner}
                                                <div className="body-content">
                                                    <div className="form-header">
                                                        <h1 id="personal-info-header" className="alpha has-tooltip-icon">
                                                            <FormattedMessage id={`${LOCALE_PREFIX}.header`} />
                                                            <ToolTip
                                                                id="personalInfoPageToolTip"
                                                                text={intl.formatMessage({
                                                                    id: `${LOCALE_PREFIX}.general-tooltip`
                                                                })}
                                                            />
                                                        </h1>
                                                    </div>
                                                    <PersonalInformationForm
                                                        onSubmit={handleSubmit(this.handleSubmit)}
                                                    />
                                                    {showPaymentSecurity && paymentSecurityExperiment === PYMT_SECURITY_CARD &&
                                                        <PaymentSecurityCard 
                                                            openPaymentSecurity={this.openPaymentSecurity} 
                                                            removePaymentSecurity={removePaymentSecurity}
                                                            hasPaymentSecurity={hasPaymentSecurity} 
                                                        />
                                                    }
                                                    {bmlEsignInfo}
                                                </div>
                                            </StickyBody>
                                            <StickyFooter fixToBottom={false} fadedBackground={true}>
                                                <div className="body-content">
                                                    <div id="action-buttons" className="buttons">
                                                        <Button
                                                            data-automation-id="continue"
                                                            btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                                            id="personalInfoContinueBtn"
                                                            onClick={this.handleClickContinue}
                                                            disabled={submitting}
                                                        >
                                                            {nextButtonText}
                                                        </Button>
                                                        <CancelUrl
                                                            componentType={COMPONENT_STYLE.LINK_BUTTON}
                                                            fptiEvent={{
                                                                stateName: 'apply_pp_credit_personalinfopage',
                                                                transitionName: 'cancel_apply_pp_credit_personalinfopage'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </StickyFooter>
                                        </StickyContainer>
                                        <div id="form-secondary-info" className="body-content">
                                            <p className="tertiary">
                                                <FormattedMessage id={`${LOCALE_PREFIX}.lender-info`} />
                                            </p>
                                        </div>
                                    </div>
                                    <aside
                                        id="content-right"
                                        className={`${(flow === FLOW_TYPE.TESLA) ? 'span11' : 'span12'} table-cell hide-for-mobile`}
                                    >
                                        <AsideContentContainer />
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer showCancelUrl={flow !== FLOW_TYPE.TESLA} />
                <link rel="prefetch" href={usTermsUri} as="document" />
                {TERMS_RESOURCES_TO_PREFETCH.map((link, index) => <link key={index} rel="prefetch" href={link.href} as={link.as} />)}
                {showPaymentSecurityDetails() && 
                    <PaymentSecurityPage
                        onCloseModal={this.closePaymentSecurity}
                    />
                }
                
            </div>
        );
    }
}

export const mapStateToProps = state => {
    const initialValues = getInitialFormValues(state);
    const griffinPhoneHandler = GriffinPhone.createHandler(state.serverData.localityMetadata);
    const formValues = getFormValues(FORM_ID)(state) || {};
    const formattedPhone = (formValues.telephone) ? formatPhoneNumber(griffinPhoneHandler, formValues.telephone) : undefined;
    const isMiniBrowser = _.get(state, 'serverData.contextType', '') === CONTEXT_TYPE.MB_CONTEXT;
    const usTermsUri = _.get(state, 'serverData.featureFlags.usTermsUri');
    const applicationType = _.get(state, 'serverData.applyType');
    const isPaymentSecurityDetailsVisible = false;
    const paymentSecurityExcludedStates = _.get(state, 'serverData.featureFlags.paymentSecurityExcludedStates', []);
    const wireOnPaymentSecurity = _.get(state, 'serverData.featureFlags.wireOnPaymentSecurity', false);
    const userNormalizedAddressState = _.get(state, 'serverData.normalizedState', '') || _.get(state, 'serverData.billingAddress.state', '');
    const showPaymentSecurity = wireOnPaymentSecurity && !paymentSecurityExcludedStates.includes(userNormalizedAddressState);

    if (applicationType !== APPLY_TYPE.FAST) {
        initialValues.telephone = '';
    }

    return {
        initialValues, // redux-form will use this to initialize the UI form
        creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
        user: _.get(state, 'serverData.user'),
        isPayInFullNowAvailable: _.get(state, 'serverData.isPayInFullNowAvailable'),
        applicationType,
        formValues,
        formattedPhone,
        isMiniBrowser,
        incentivesDetails: _.get(state, 'serverData.incentivesDetails') || {},
        flow: _.get(state, 'serverData.flow'),
        usTermsUri,
        isPaymentSecurityDetailsVisible,
        hasPaymentSecurity: _.get(state, 'serverData.enrollPymtSecurity', false),
        paymentSecurityExperiment: _.get(state, 'serverData.elmo.PaymentSecurity'),
        showPaymentSecurity
    };
};

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'prepare_apply_pp_credit_personalinfopage'));
    },
    onClickContinue(formValues) {
        const telephone = _.get(formValues, 'telephone');
        if (!telephone) {
            dispatch(showPhoneOptOutCheckbox(true));
        }
        dispatch(submit(FORM_ID));
    },
    onClickX() {
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'cancel_x_apply_pp_credit_personalinfopage'));
    },
    submitCallback(formValues, applicationType, nextPage, paymentSecurity) {
        formValues.phoneOptOut = formValues.phoneOptOut || false;
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'process_apply_pp_credit_personalinfopage'));
        //If Asset Lite Phase 2 is on treatment_1 then click of continue on personal info page should call CIS.
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'process_CIS'));
        dispatch(spinnerOpen());
        return dispatch(submitForCreditAccountIdentification(formValues, paymentSecurity));
    },
    onOpenPaymentSecurityModal() {
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'ppc_applctn_pmt_sec_get_details_pressed',));
    },
    onClosePaymentSecurityModal() {
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'process_close_payment_security_modal',));
        dispatch(reset(PYMT_SECURITY_FORM_ID));
    },
    async removePaymentSecurity() {
        dispatch(spinnerOpen());
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'ppc_applctn_pmt_sec_remove_it_pressed'));
        await dispatch(change(PYMT_SECURITY_FORM_ID, READ_PROGRAM_AGREEMENT_CHECKBOX_KEY, false));
        const submitData = {
            agreeToPymtSecurity: false
        };

        return dispatch(submitPaymentSecurity(submitData));
    }
});

// redux-form lives where the form `submit` is
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: FORM_ID,
        onSubmitFail: handleSubmitFail,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(PersonalInformationPage)
));
